import Nullstack from 'nullstack';
export default function IconBrandAppstore({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-appstore",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("path", {
    d: "M8 16l1.106 -1.99m1.4 -2.522l2.494 -4.488"
  }), "   ", Nullstack.element("path", {
    d: "M7 14h5m2.9 0h2.1"
  }), "   ", Nullstack.element("path", {
    d: "M16 16l-2.51 -4.518m-1.487 -2.677l-1.003 -1.805"
  }), " ");
}